<h1 class="title">{{ content.lienU }}</h1>

<div *ngIf="parameter$ | async as parameter">
  <div class="contacts" fxLayout="column" fxLayoutGap="16px">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
      <div
        class="global-icon"
        fxFlex="24px"
        style="height: 24px; width: 24px;"
        [ngStyle]="{
          'mask-image': 'url(assets/icons/call.svg)',
          '-webkit-mask-image': 'url(assets/icons/call.svg)'
        }"
        alt="phone"
      ></div>
      <a href="tel:{{ parameter.phoneNumber }}">{{ parameter.phoneNumber }}</a>
    </div>

    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
      <div
        class="global-icon"
        fxFlex="24px"
        style="height: 24px; width: 24px;"
        [ngStyle]="{
          'mask-image': 'url(assets/icons/email.svg)',
          '-webkit-mask-image': 'url(assets/icons/email.svg)'
        }"
        alt="email"
      ></div>
      <a href="mailto:{{ parameter.supportEmail }}">{{ parameter.supportEmail }}</a>
    </div>

    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
      <div
        class="global-icon"
        fxFlex="24px"
        style="height: 24px; width: 24px;"
        [ngStyle]="{
          'mask-image': 'url(assets/icons/location.svg)',
          '-webkit-mask-image': 'url(assets/icons/location.svg)'
        }"
        alt="address"
      ></div>
      <a *ngIf="parameter.address && parameter.mapsSharedLink" [href]="parameter.mapsSharedLink" target="_blank">
        {{ parameter.address }}
      </a>
    </div>
  </div>
</div>

<ul class="links">
  <li *ngIf="false" routerLink="/blog/list" fxHide.gt-xs>
    <a>
      <img class="imgRed" src="assets/icons/iconRed.png" alt="Icone red" />
      {{ content.actual }}
    </a>
  </li>
  <li routerLink="about/legal">
    <a><div class="dot"></div><span>Mentions légales</span></a>
  </li>
  <li routerLink="about/general-condition">
    <a><div class="dot"></div><span>Conditions générales</span></a>
  </li>
  <li routerLink="about/cookies">
    <a><div class="dot"></div><span>Les Cookies sur Imtech</span></a>
  </li>
  <li routerLink="about/security">
    <a><div class="dot"></div><span>Sécurité et confidentialité</span></a>
  </li>
</ul>
